import { ExpressTier } from "data-types";

const GERMANY_COUNTRY_ID = "DE";

// HL-13005: shared by DeliveryOptionPanel and UnavailableDeliveryMethodPopup so both name DHL the same way.
export const isDhlNextDayDisplayed = (params: { country?: string; isPersonalAddress: boolean; tiersToShow: ExpressTier[] }): boolean => {
  const { country, isPersonalAddress, tiersToShow } = params;
  return isPersonalAddress && tiersToShow.some((tier) => tier.tier === "next_day") && country?.toUpperCase() === GERMANY_COUNTRY_ID;
};

export const resolveDhlTitleKey = (params: { country?: string; isPreOrderCart: boolean; contentType?: string; isNextDayDisplayed: boolean }): string => {
  const { country, isPreOrderCart, contentType, isNextDayDisplayed } = params;
  if (isPreOrderCart) {
    return `serviceOptions/pre_order_dhl_title_${country?.toLowerCase()}`;
  }
  if (contentType === "test_lab") {
    return `serviceOptions/test_lab_dhl_title_${country?.toLowerCase()}`; // kits ship in 2-4 business days, not 24-48h
  }
  return isNextDayDisplayed
    ? `serviceOptions/service_option_dhl_title_${country?.toLowerCase()}_next_day`
    : `serviceOptions/service_option_dhl_title_${country?.toLowerCase()}`;
};
